import { render } from "./InformacoesServico.vue?vue&type=template&id=3c776906"
import script from "./InformacoesServico.vue?vue&type=script&lang=js"
export * from "./InformacoesServico.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__